<div class="flex flex-row flex-wrap gap-8">
  <pr-statistic
    label="Cost per entry"
    tooltip="Estimated cost per entry for this campaign run"
  >
    {{ estimates().costPerEntry | currency }}
  </pr-statistic>
  <pr-statistic
    label="Estimated Cost"
    tooltip="Estimated cost of this campaign run"
  >
    {{ estimates().estimatedCost | currency }}
  </pr-statistic>
</div>
